// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3bhdO","select":"Header_select__39KAy","clinic":"Header_clinic__cDSyZ"};